module.exports = __webpack_public_path__ + "static/media/next-disable.33ca16bf.svg";